// Shared vehicle ID options.
// Vehicle IDs are stored as display strings (do not force normalization here);
// consumers can normalize for search/compare when needed.

const normalizeForSearch = (value) =>
  String(value || "")
    .replace(/[^a-z0-9]+/gi, "")
    .toUpperCase();

export const VEHICLE_ID_GROUPS = [
  {
    label: "Paddle Cycle",
    ids: [
      "PC 01-A",
      "PC 02-A",
      "PC 03-A",
      "PC 04-A",
      "PC 05-A",
      "PC 06-A",
      "PC 07-A",
      "PC 08-A",
      "PC 09-A",
      "PC 10-A",
      "PC 11-A",
      "PC 12-A",
      "PC 13-A",
      "PC 14-A",
      "PC 01-D",
      "PC 02-D",
      "PC 03-D",
      "PC 04-D",
      "PC 05-D",
      "PC 06-D",
      "PC 07-D",
      "PC 08-D",
      "PC 09-D",
      "PC 10-D",
      "PC 11-D",
      "PC 12-D",
    ],
  },
  {
    label: "Electric Cycle",
    ids: [
      "EC 01-A",
      "EC 02-A",
      "EC 03-A",
      "EC 04-A",
      "EC 05-A",
      "EC 06-A",
      "EC 01-D",
      "EC 02-D",
      "EC 03-D",
      "EC 04-D",
      "EC 05-D",
      "EC 06-D",
    ],
  },
  {
    label: "EV Kick Scooter",
    ids: [
      "KS 001-A",
      "KS 002-A",
      "KS 003-A",
      "KS 004-A",
      "KS 001-D",
      "KS 002-D",
      "EVSF 602601",
      "EVSF 602602",
      "EVSF 602603",
      "EVSF 602604",
      "EVSF 602605",
      "EVSF 602606",
      "EVSF 602607",
      "EVSF 602608",
      "EVSF 602609",
      "EVSF 602610",
      "EVSF 602611",
      "EVSF 602612",
      "EVSF 602613",
      "EVSF 602614",
      "EVSF 602615",
      "EVSF 602616",
      "EVSF 602617",
      "EVSF 602618",
      "EVSF 602619",
      "EVSF 602620",
      "EVSF 602621",
      "EVSF 602622",
      "EVSF 602623",
      "EVSF 602624",
      "EVSF 602625",
      "EVSF 602626",
      "EVSF 602627",
      "EVSF 602628",
      "EVSF 602629",
      "EVSF 602630",
      "EVSF 602631",
      "EVSF 602632",
      "EVSF 602633",
      "EVSF 602634",
      "EVSF 602635",
      "EVSF 602636",
      "EVSF 602637",
      "EVSF 602638",
      "EVSF 602639",
      "EVSF 602640",
      "EVSF 602641",
      "EVSF 602642",
      "EVSF 602643",
      "EVSF 602644",
      "EVSF 602645",
      "EVSF 602646",
      "EVSF 602647",
      "EVSF 602648",
      "EVSF 602649",
      "EVSF 602650",
    ],
  },
  {
    label: "EVSF Scooter",
    ids: [
      "EVSF 602601",
      "EVSF 602602",
      "EVSF 602603",
      "EVSF 602604",
      "EVSF 602605",
      "EVSF 602606",
      "EVSF 602607",
      "EVSF 602608",
      "EVSF 602609",
      "EVSF 602610",
      "EVSF 602611",
      "EVSF 602612",
      "EVSF 602613",
      "EVSF 602614",
      "EVSF 602615",
      "EVSF 602616",
      "EVSF 602617",
      "EVSF 602618",
      "EVSF 602619",
      "EVSF 602620",
      "EVSF 602621",
      "EVSF 602622",
      "EVSF 602623",
      "EVSF 602624",
      "EVSF 602625",
      "EVSF 602626",
      "EVSF 602627",
      "EVSF 602628",
      "EVSF 602629",
      "EVSF 602630",
      "EVSF 602631",
      "EVSF 602632",
      "EVSF 602633",
      "EVSF 602634",
      "EVSF 602635",
      "EVSF 602636",
      "EVSF 602637",
      "EVSF 602638",
      "EVSF 602639",
      "EVSF 602640",
      "EVSF 602641",
      "EVSF 602642",
      "EVSF 602643",
      "EVSF 602644",
      "EVSF 602645",
      "EVSF 602646",
      "EVSF 602647",
      "EVSF 602648",
      "EVSF 602649",
      "EVSF 602650",
    ],
  },
  {
    label: "Kids EV Car",
    ids: ["TC 01-A", "TC 02-A", "TC 01-D", "TC 02-D"],
  },
  {
    label: "Kids Paddle Scooter",
    ids: ["PS 01-A", "PS 02-A"],
  },
  {
    label: "Double Seat Cycle",
    ids: ["DS 01-A", "DS 02-A"],
  },
  {
    label: "MINK",
    ids: [
      "EVM1024002",
      "EVM1024003",
      "EVM1024004",
      "EVM1024005",
      "EVM1024006",
      "EVM1024009",
      "EVM1024010",
      "EVM1024011",
      "EVM1024012",
      "EVM1024014",
      "EVM1024016",
      "EVM1024017",
      "EVM1024018",
      "EVM1024019",
      "EVM1024020",
      "EVM1024021",
      "EVM1024022",
      "EVM1024023",
      "EVM1025029",
      "EVM1025030",
      "EVM1025031",
      "EVM1025032",
      "EVM1025033",
      "EVM1025034",
      "EVM1025035",
      "EVM1025036",
      "EVM1025037",
      "EVM1025038",
      "EVM1024001",
      "EVM1025026",
      "EVM1025027",
      "EVM1025028",
    ],
  },
  {
    label: "CITY",
    ids: [
      "EVM2025001",
      "EVM2025002",
      "EVM2025004",
      "EVM2025005",
      "EVM2025006",
      "EVM5025001",
      "EVM5025002",
      "EVM5025003",
      "EVM5025004",
      "EVM5025005",
      "EVM5025006",
      "EVM5025007",
      "EVM5025009",
      "EVM5025010",
      "EVM5025011",
      "EVM5025012",
      "EVM5025013",
      "EVM5025014",
      "EVM5025015",
      "EVM5025016",
      "EVM5025017",
      "EVM5025018",
      "EVM5025019",
      "EVM5025020",
      "EVM5025021",
      "EVM5025022",
      "EVM5025023",
      "EVM5025024",
      "EVM5025025",
      "EVM5025026",
      "EVM5025027",
      "EVM5025028",
      "EVM5025029",
      "EVM5025030",
      "EVM5025031",
      "EVM5025032",
      "EVM5025033",
      "EVM5025034",
      "EVM5025035",
      "EVM5025036",
      "EVM5025037",
      "EVM5025038",
      "EVM5025039",
      "EVM5025040",
      "EVM5025041",
      "EVM5025042",
      "EVM5025043",
      "EVM5025044",
      "EVM5025045",
      "EVM5025046",
      "EVM5025047",
      "EVM5025048",
      "EVM5025049",
      "EVM5025050",
    ],
  },
  {
    label: "KING",
    ids: ["EVM2025007", "EVM2025008", "EVM2025009"],
  },
];

export const VEHICLE_MODEL_OPTIONS = VEHICLE_ID_GROUPS.map((g) => g.label);

export const flattenVehicleIdGroups = (groups) => {
  const out = [];
  const seen = new Set();
  for (const group of Array.isArray(groups) ? groups : []) {
    for (const id of Array.isArray(group?.ids) ? group.ids : []) {
      const key = normalizeForSearch(id);
      if (!key || seen.has(key)) continue;
      seen.add(key);
      out.push(id);
    }
  }
  return out;
};

// Backwards-compatible flat options list.
export const VEHICLE_ID_OPTIONS = flattenVehicleIdGroups(VEHICLE_ID_GROUPS);

export const getVehicleIdGroupsForModel = (model) => {
  const m = String(model || "").trim();
  if (!m) return VEHICLE_ID_GROUPS;

  const mKey = normalizeForSearch(m);
  const match = VEHICLE_ID_GROUPS.find((g) => normalizeForSearch(g?.label) === mKey);
  return match ? [match] : VEHICLE_ID_GROUPS;
};

export const filterVehicleIdGroups = (query, groups = VEHICLE_ID_GROUPS) => {
  const q = String(query || "").trim().toUpperCase();
  const qNorm = normalizeForSearch(q);

  const base = Array.isArray(groups) ? groups : [];

  if (!q && !qNorm) return base;

  return base
    .map((group) => {
    const ids = (Array.isArray(group?.ids) ? group.ids : []).filter((id) => {
      const raw = String(id || "").toUpperCase();
      if (q && raw.includes(q)) return true;
      if (qNorm && normalizeForSearch(id).includes(qNorm)) return true;
      return false;
    });

    return { ...group, ids };
    })
    .filter((group) => (Array.isArray(group?.ids) ? group.ids.length > 0 : false));
};
